import { workflowConstants } from "../_constants";

export function workflowList(state = {}, action) {
  switch (action.type) {
    case workflowConstants.GET_ALL_WORKFLOW_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.GET_ALL_WORKFLOW_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.GET_ALL_WORKFLOW_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function workflowById(state = {}, action) {
  switch (action.type) {
    case workflowConstants.GET_WORKFLOW_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.GET_WORKFLOW_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.GET_WORKFLOW_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function workflowTopCard(state = {}, action) {
  switch (action.type) {
    case workflowConstants.GET_WORKFLOW_TOP_CARD_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.GET_WORKFLOW_TOP_CARD_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.GET_WORKFLOW_TOP_CARD_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function workflow(state = {}, action) {
  switch (action.type) {
    case workflowConstants.ADD_WORKFLOW_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.ADD_WORKFLOW_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.ADD_WORKFLOW_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function editWorkflow(state = {}, action) {
  switch (action.type) {
    case workflowConstants.EDIT_WORKFLOW_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.EDIT_WORKFLOW_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.EDIT_WORKFLOW_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function addConfiguredWorkflow(state = {}, action) {
  switch (action.type) {
    case workflowConstants.ADD_CONFIGURED_WORKFLOW_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.ADD_CONFIGURED_WORKFLOW_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.ADD_CONFIGURED_WORKFLOW_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
export function runWorkflow(state = {}, action) {
  switch (action.type) {
    case workflowConstants.RUN_WORKFLOW_BY_JOB_ID_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.RUN_WORKFLOW_BY_JOB_ID_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.RUN_WORKFLOW_BY_JOB_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function databricksJobStatus(state = {}, action) {
  switch (action.type) {
    case workflowConstants.GET_DATABRICKS_JOB_STATUS_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.GET_DATABRICKS_JOB_STATUS_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.GET_DATABRICKS_JOB_STATUS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function workflowFilters(state = {}, action) {
  switch (action.type) {
    case workflowConstants.GET_WORKFLOW_FILTERS_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.GET_WORKFLOW_FILTERS_SUCCESS:
      return {
        items: action.data,
      };
    case workflowConstants.GET_WORKFLOW_FILTERS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function gitRepoByConnectionId(state = {}, action) {
  switch (action.type) {
    case workflowConstants.GET_GIT_REPO_BY_CONNECTION_ID_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.GET_GIT_REPO_BY_CONNECTION_ID_SUCCESS:
      return {
        items: action.data,
      };
    case workflowConstants.GET_GIT_REPO_BY_CONNECTION_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeWorkflow(state = {}, action) {
  switch (action.type) {
    case workflowConstants.ACTIVATE_WORKFLOW_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.ACTIVATE_WORKFLOW_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.ACTIVATE_WORKFLOW_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeWorkflowByConnectionId(state = {}, action) {
  switch (action.type) {
    case workflowConstants.GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_REQUEST:
      return {
        loading: true,
      };
    case workflowConstants.GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_SUCCESS:
      return {
        item: action.data,
      };
    case workflowConstants.GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
